import React from 'react';

import DocumentsForm from 'buyside/components/presentation/Form/DocumentsForm/documentsForm';

const { employerProfileSupportingDocumentNames } = require('buyside/util/constantsFromRails.json');

// NOTE: make sure to update the appropriate schema in util/fundProfileShowPageValidationSchemata

const MarketingMaterialsForm = ({ values }) => {
  return (
    <DocumentsForm
      attr="fundProfile.marketingMaterials"
      categories={employerProfileSupportingDocumentNames}
      title="Supporting Documents"
      marketingMaterialsValues={values.fundProfile.marketingMaterials}
      withCategory
      withUrl
    />
  );
};

export default MarketingMaterialsForm;
